module.exports = __webpack_public_path__ + "img/circle-check.6051fe6f.png";